import PwaInstall, {
  type PwaInstallHandle,
} from "@aitisal/ui/common/PwaInstall";
import { TooltipProvider } from "@aitisal/ui/portal/tooltip";
import { Outlet, createRootRoute, useNavigate } from "@tanstack/react-router";
import React, { useCallback, useEffect, useRef } from "react";
import { useSession } from "../stores/sessionStore";

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <NotFoundComponent />,
});

const NotFoundComponent = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate({ to: "/", replace: true });
  }, [navigate]);
  return null;
};

function RootComponent() {
  const pwaInstallRef = useRef<PwaInstallHandle>(null);
  const { setBrandId } = useSession() as any;

  // Set brandId from meta tag on app initialization
  useEffect(() => {
    const metaBrandId = document
      .querySelector('meta[name="brand"]')
      ?.getAttribute("content");
    if (metaBrandId) {
      setBrandId(metaBrandId);
    }
  }, [setBrandId]);

  const handleInstallSuccess = useCallback((event: CustomEvent) => {
    console.log("PWA installed successfully!", event.detail);
  }, []);

  const handleInstallFail = useCallback((event: CustomEvent) => {
    console.log("PWA installation failed.", event.detail);
  }, []);

  const handleInstallAvailable = useCallback((event: CustomEvent) => {
    console.log("PWA is available for installation.", event.detail);
  }, []);

  const handleUserChoiceResult = useCallback((event: CustomEvent) => {
    console.log("User choice result:", event.detail);
  }, []);

  return (
    <React.Fragment>
      <PwaInstall
        ref={pwaInstallRef}
        manualChrome={true}
        manualApple={true}
        onInstallSuccess={handleInstallSuccess}
        onInstallFail={handleInstallFail}
        onInstallAvailable={handleInstallAvailable}
        onUserChoiceResult={handleUserChoiceResult}
      />
      <TooltipProvider delayDuration={100}>
        <Outlet />
      </TooltipProvider>
    </React.Fragment>
  );
}
